export const tools = {
  excel: {
    Freq: {
      Rarely: 105,
      Sometimes: 218,
      Often: 515,
    },

    Like: {
      NotAtALL: 126,
      Somewhat: 397,
      VeryMuch: 304,
    },
  },
  tableau: {
    Freq: { Rarely: 85, Sometimes: 138, Often: 365 },
    Like: { NotAtALL: 32, Somewhat: 151, VeryMuch: 399 },
  },
  powerpoint: {
    Freq: { Rarely: 62, Sometimes: 184, Often: 303 },
    Like: { NotAtALL: 96, Somewhat: 281, VeryMuch: 167 },
  },
  powerBI: {
    Freq: { Rarely: 67, Sometimes: 122, Often: 197 },
    Like: { NotAtALL: 41, Somewhat: 150, VeryMuch: 192 },
  },
  R: {
    Freq: { Rarely: 65, Sometimes: 115, Often: 191 },
    Like: { NotAtALL: 17, Somewhat: 111, VeryMuch: 239 },
  },
  googlesheets: {
    Freq: { Rarely: 67, Sometimes: 136, Often: 162 },
    Like: { NotAtALL: 61, Somewhat: 188, VeryMuch: 109 },
  },
  illustrator: {
    Freq: { Rarely: 40, Sometimes: 97, Often: 194 },
    Like: { NotAtALL: 24, Somewhat: 105, VeryMuch: 197 },
  },
  penAndPaper: {
    Freq: { Rarely: 33, Sometimes: 123, Often: 174 },
    Like: { NotAtALL: 6, Somewhat: 76, VeryMuch: 242 },
  },
  GGPlot2: {
    Freq: { Rarely: 62, Sometimes: 97, Often: 166 },
    Like: { NotAtALL: 10, Somewhat: 109, VeryMuch: 203 },
  },
  python: {
    Freq: {
      Rarely: 57,
      Sometimes: 108,
      Often: 150,
    },

    Like: {
      NotAtALL: 24,
      Somewhat: 125,
      VeryMuch: 164,
    },
  },
  D3: {
    Freq: { Rarely: 60, Sometimes: 78, Often: 126 },
    Like: { NotAtALL: 10, Somewhat: 87, VeryMuch: 161 },
  },
  figma: {
    Freq: { Rarely: 46, Sometimes: 73, Often: 126 },
    Like: { NotAtALL: 11, Somewhat: 97, VeryMuch: 137 },
  },
  plotly: {
    Freq: { Rarely: 49, Sometimes: 81, Often: 51 },
    Like: { NotAtALL: 10, Somewhat: 82, VeryMuch: 88 },
  },
  RAWGraphs: {
    Freq: { Rarely: 35, Sometimes: 79, Often: 37 },
    Like: { NotAtALL: 6, Somewhat: 50, VeryMuch: 93 },
  },
  datawrapper: {
    Freq: { Rarely: 42, Sometimes: 53, Often: 43 },
    Like: { NotAtALL: 6, Somewhat: 48, VeryMuch: 81 },
  },
  googleDataStudio: {
    Freq: { Rarely: 39, Sometimes: 50, Often: 45 },
    Like: { NotAtALL: 23, Somewhat: 74, VeryMuch: 36 },
  },
  arcGIS: {
    Freq: { Rarely: 57, Sometimes: 43, Often: 30 },
    Like: { NotAtALL: 20, Somewhat: 65, VeryMuch: 44 },
  },
  flourish: {
    Freq: { Rarely: 28, Sometimes: 54, Often: 49 },
    Like: { NotAtALL: 1, Somewhat: 47, VeryMuch: 81 },
  },
  QGIS: {
    Freq: { Rarely: 37, Sometimes: 54, Often: 37 },
    Like: { NotAtALL: 12, Somewhat: 61, VeryMuch: 53 },
  },
  mapbox: {
    Freq: { Rarely: 39, Sometimes: 59, Often: 21 },
    Like: { NotAtALL: 3, Somewhat: 59, VeryMuch: 54 },
  },
  canvas: {
    Freq: { Rarely: 36, Sometimes: 54, Often: 21 },
    Like: { NotAtALL: 8, Somewhat: 69, VeryMuch: 31 },
  },
};
